/**
 *    Copyright 2018 the original author or authors
 * 
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 * 
 *        http://www.apache.org/licenses/LICENSE-2.0
 * 
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { DialogData } from './models/dialogData';
import { ObjectWithLinks, RelationTypes } from '../../../common';

@Component({
  selector: 'ext-api-item-add',
  templateUrl: './api-item-add-dialog.component.html'
})
export class ApiItemAddDialogComponent {
  public multiSelect: boolean = true;
  public selected: string[];

  constructor(
    public dialogRef: MatDialogRef<ApiItemAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.selected = data.response.map(d => d._links.self.href);
    if (data.property.relationShipType === RelationTypes.SINGLE) {
      this.multiSelect = false;
    }
  } // constructor()

  onOkay(): void {
    this.dialogRef.close(this.selected);
  }
}
